import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import { useState } from "react";
import { Menu, User, Clock } from "lucide-react";
import "./layout.css";
import { useEffect, useRef } from "react";
import { FaBell } from "react-icons/fa";
// import "../../Pages/Dashboard/dashboard.css";
import axios from "axios";
import toast from "react-hot-toast";




const parseExpiry = (value) => {
  if (!value) return null;
  const num = Number(value);
  if (!Number.isNaN(num)) return num < 1e12 ? num * 1000 : num; // epoch seconds or ms
  const t = new Date(value).getTime(); // ISO string
  return Number.isNaN(t) ? null : t;
};

const formatTime = (totalSeconds) => {
  const pad = (n) => String(n).padStart(2, "0");
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
};

const Layout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const navigate = useNavigate();
  const [hideTopIcons, setHideTopIcons] = useState(false);

  const [unreadCount, setUnreadCount] = useState(0);
  const lastAlarmTimeRef = useRef(0);
  const [remaining, setRemaining] = useState(null); // seconds left

  const API_URL = process.env.REACT_APP_API_DJANGO_URL;



  // // One-time message right after login
  // useEffect(() => {
  //   if (localStorage.getItem("session_welcome") === "true") {
  //     localStorage.removeItem("session_welcome");
  //     toast.success("Your session is active for 1 hour", { duration: 5000 });
  //   }
  // }, []);

  // // Session countdown timer
  // useEffect(() => {
  //   const expiry = parseExpiry(localStorage.getItem("session_expires_at"));
  //   if (!expiry) return undefined;

  //   const tick = () =>
  //     setRemaining(Math.max(0, Math.floor((expiry - Date.now()) / 1000)));

  //   tick();
  //   const id = setInterval(tick, 1000);
  //   return () => clearInterval(id);
  // }, []);


  // Session countdown timer + one-time welcome message
  useEffect(() => {
    const expiry = parseExpiry(localStorage.getItem("session_expires_at"));
    if (!expiry) return undefined;

    const getSecs = () =>
      Math.max(0, Math.floor((expiry - Date.now()) / 1000));

    // Welcome message uses the SAME remaining time as the timer
    if (localStorage.getItem("session_welcome") === "true") {
      localStorage.removeItem("session_welcome");

      const secs = getSecs();
      const h = Math.floor(secs / 3600);
      const m = Math.floor((secs % 3600) / 60);

      let text;
      if (secs >= 3590) text = "You are in demo & it will be active for 1 hour only";
      else if (h > 0) text = `You have ${h} hour ${m} minutes left`;
      else if (m > 0) text = `You have ${m} minute${m === 1 ? "" : "s"} left`;
      else text = `You have ${secs} seconds left`;

      toast.success(text, { duration: 5000 });
    }

    // const tick = () => {
    //   const secs = getSecs();
    //   setRemaining(secs);
    //   if (secs === 0) {
    //     localStorage.clear();
    //     navigate("/", { replace: true });
    //   }
    // };

    // tick();
    // const id = setInterval(tick, 1000);
    // return () => clearInterval(id);

    let id;

    const tick = () => {
      const secs = getSecs();
      setRemaining(secs);
      if (secs === 0) {
        clearInterval(id); // stop the timer so the redirect only fires once
        localStorage.clear();
        navigate("/", { replace: true, state: { sessionExpired: true } });
      }
    };

    tick();
    id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [navigate]);

  const fetchAlarms = async () => {
    try {
      const token = localStorage.getItem("accessToken");

      const res = await axios.get(
        `${API_URL}/api/get_alarms_notification/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      const alarmList = res.data.data || [];
      const active = alarmList.filter((a) => !a.cleared);

      if (alarmList.length > 0) {
        const newestTime = alarmList[0].createdTime;

        if (
          lastAlarmTimeRef.current !== 0 &&
          newestTime > lastAlarmTimeRef.current
        ) {
          toast.error("🚨 New Alarm Triggered!");
          localStorage.removeItem("alarmsViewed");
        }

        lastAlarmTimeRef.current = newestTime;
      }

      setUnreadCount(
        localStorage.getItem("alarmsViewed") === "true"
          ? 0
          : active.length
      );
    } catch (err) {
      console.error("Alarm fetch error:", err);
    }
  };

  useEffect(() => {
    fetchAlarms();

    const interval = setInterval(() => {
      fetchAlarms();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    let timeout;

    const handleScroll = () => {
      setHideTopIcons(true);

      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setHideTopIcons(false); // show again after scroll stops
      }, 150);
    };

    const container = document.querySelector(".page-wrapper");

    container?.addEventListener("scroll", handleScroll);

    return () => container?.removeEventListener("scroll", handleScroll);
  }, []);

  //   return (
  //     <div className="app-layout">

  //       <Sidebar collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} />

  // <div
  //   className="alarm-bell"
  //   // className={`alarm-bell ${hideTopIcons ? "hide-icons" : ""}`}
  //   onClick={() => {
  //     localStorage.setItem("alarmsViewed", "true");
  //     setUnreadCount(0);
  //     navigate("/alarms-notification");
  //   }}
  // >
  //   <FaBell size={25} />

  //   {unreadCount > 0 && (
  //     <span className="alarm-badge">
  //       {unreadCount}
  //     </span>
  //   )}
  // </div>


  //    <div 
  //   className="profile-icon"
  //   // className={`profile-icon ${hideTopIcons ? "hide-icons" : ""}`}
  //     onClick={() => navigate("/profile")}>
  //   <User size={24} />
  // </div>

  //       {/* MENU BUTTON OUTSIDE SIDEBAR */}
  //       <div
  //         className="collapse-icon"
  //         onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
  //       >
  //         <Menu size={24} />
  //       </div>

  //       <div className={`main-content ${sidebarCollapsed ? "collapsed" : ""}`}>
  //         <div className="page-wrapper">
  //     <Outlet />

  //   </div>

  //   <footer className="app-footer">
  //     <p>© IgnisVigil 2026 Smart Fire Fighting Systems Monitoring Solution</p>
  //   </footer>

  //       </div>
  //     </div>
  //   );


  return (
    <div className="app-layout">
      {/* Sidebar handles its own absolute positioning toggle internally */}
      <Sidebar collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} />

      {/* Main App Workspace Area */}
      <div className={`main-content ${sidebarCollapsed ? "collapsed" : ""}`}>

        {/* Pinned Top Navbar */}
        <div className="top-navbar">
          {/* This empty spacer pushes the actions group all the way to the right */}
          <div className="navbar-spacer" />

          {/* Grouped Icons Container */}
          <div className="navbar-actions">

            {remaining !== null && (
              <div className={`session-timer ${remaining <= 300 ? "warning" : ""}`}>
                <Clock size={16} />
                <span>Session: {formatTime(remaining)}</span>
              </div>
            )}
            {/* Alarm Notification Bell */}
            <div
              className="alarm-bell"
              onClick={() => {
                localStorage.setItem("alarmsViewed", "true");
                setUnreadCount(0);
                navigate("/alarms-notification");
              }}
            >
              <FaBell size={22} />
              {unreadCount > 0 && (
                <span className="alarm-badge">{unreadCount}</span>
              )}
            </div>

            {/* Profile Avatar Control */}
            {/* <div className="profile-icon" onClick={() => navigate("/profile")}>
              <User size={20} />
            </div> */}
            {/* Profile Avatar (display only) */}
            <div className="profile-icon">
              <User size={20} />
            </div>
          </div>
        </div>

        {/* Scrollable Dashboard Frame Viewport */}
        <div className="page-wrapper">
          <Outlet />
        </div>

        {/* App Footer Context */}
        {/* <footer className="app-footer">
          <p>© IgnisVigil 2026 Smart Fire Fighting Systems Monitoring Solution</p>
        </footer> */}

        <footer className="app-footer">
          <p>© IgnisVigil 2026 Smart Fire Fighting Systems Monitoring Solution</p>

          <a
            className="powered-by"
            href="https://www.tapasyatech.in"
            target="_blank"
            rel="noopener noreferrer"
            title="Visit Tapasya Technovation"
          >
            <span className="powered-by-text">Powered by</span>
            <img
              className="powered-by-logo"
              src={process.env.PUBLIC_URL + "/TT_logo2.png"}
              alt="Tapasya Technovation"
            />
          </a>
        </footer>
      </div>
    </div>
  );
};

export default Layout;